<template>
  <div class="goods-page-wrapper">
    <!-- 可滚动区域 -->
    <div class="goods-scroll-area" ref="scrollArea" @scroll="handleScroll">
      <!-- 顶部 Banner（不可点击） -->
      <div class="brand-banner-section">
        <van-image
          lazy-load
          fit="cover"
          width="100%"
          :src="brandBannerImg"
          class="brand-banner-img"
        />
        <div class="brand-name-overlay" v-if="form.brandName">
          <span class="brand-name-text">{{ form.brandName }}</span>
        </div>
      </div>

      <!-- 排序区 -->
      <SortFilter
        :priceType="form.priceType"
        @sort-default="setNomal"
        @sort-price="setPrictType"
      />

      <!-- 商品列表 -->
      <loading v-if="loading"></loading>
      <div v-else>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list v-model="loading2" :finished="finished" finished-text="没有更多了" @load="nextPage">
            <goods-list-com :DataList="zyData"> </goods-list-com>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>

    <!-- 返回顶部按钮 -->
    <div v-if="showBackTop" class="back-top-btn" @click="scrollToTop">
      <van-icon name="arrow-up" size="1.2rem" />
      <span>顶部</span>
    </div>
  </div>
</template>

<script>
import GoodsListCom from "../../components/GoodsListCom.vue";
import SortFilter from "../../components/goodlist/SortFilter.vue";

const defaultBannerImg = 'https://shijieux.oss-cn-beijing.aliyuncs.com/ecms/2026/06/22/20260622_da0c45ae8a9348298c04e2d9fee4d0a7.png'

export default {
  name: 'ProductList',
  data() {
    return {
      loading: true,
      loading2: false,
      finished: false,
      isLoading: false,
      showBackTop: false,
      zyData: [],
      brandBannerImg: defaultBannerImg,
      form: {
        cardId: '',
        current: 1,
        size: 10,
        brandName: '',
        cityCode: '',
        upgradeFlag: '',
        bathId: '',
        priceType: null,
      },
    }
  },
  components: { GoodsListCom, SortFilter },
  methods: {
    getRouteBrandName() {
      const raw = this.$route.params.brandName || '';
      if (!raw) return '';
      try {
        return decodeURIComponent(raw);
      } catch (e) {
        return raw;
      }
    },
    loadList() {
      const brandName = this.getRouteBrandName();
      if (!brandName) {
        this.$Toast('商品信息有误，请重新选择');
        return;
      }
      this.form.cardId = localStorage.getItem('cardId');
      this.form.cityCode = localStorage.getItem('cityCode');
      this.form.upgradeFlag = localStorage.getItem('upgradeFlag');
      this.form.bathId = localStorage.getItem('bathId');
      this.form.brandName = brandName;
      this.form.current = 1;
      this.zyData = [];
      this.finished = false;
      this.loading = true;
      this.getData();
    },

    // ---------- 排序 ----------
    setPrictType() {
      if (this.form.priceType) {
        this.form.priceType = this.form.priceType === '1' ? '0' : '1'
      } else {
        this.form.priceType = '1'
      }
      this.onRefresh()
    },
    setNomal() {
      this.form.priceType = null
      this.onRefresh()
    },

    nextPage() {
      if (this.zyData.length >= 10) {
        this.loading = false;
        this.form.current += 1;
        this.getData();
      }
    },
    onRefresh() {
      this.form.current = 1;
      this.finished = false;
      this.zyData = [];
      this.getData();
      this.isLoading = false;
    },
    getData() {
      this.$api
        .queryProductInfoHomeNew(this.form)
        .then((res) => {
          if (res.code == 1) {
            this.$Toast(res.msg);
            return;
          }
          if (this.form.current == 1) {
            this.zyData = res.data.records;
          } else {
            this.zyData.push(...res.data.records);
          }
          // 如果后端返回了品牌 banner 图，优先使用
          if (res.data.brandBannerImg) {
            this.brandBannerImg = res.data.brandBannerImg;
          }
          if (this.form.current >= res.data.pages) {
            this.finished = true;
          }
          this.loading = false;
          this.isLoading = false;
          this.loading2 = false;
        })
        .catch(() => {
          this.loading = false;
          this.isLoading = false;
          this.loading2 = false;
        });
    },

    // ---------- 滚动 ----------
    handleScroll(e) {
      this.showBackTop = e.target.scrollTop > 300;
    },
    scrollToTop() {
      if (this.$refs.scrollArea) {
        this.$refs.scrollArea.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
  },
  mounted() {
    this.loadList();
  },
}

</script>

<style lang="scss" scoped>
@import '@/styles/goodslist.scss';

.goods-scroll-area {
  padding-top: 0;
}

.brand-banner-section {
  position: relative;
  width: 100%;
  aspect-ratio: 750 / 280;
  overflow: hidden;

  .brand-banner-img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .brand-name-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.5rem 0.8rem;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.35));

    .brand-name-text {
      color: #fff;
      font-size: 1rem;
      font-weight: 600;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
